import { supabase, isSupabaseConfigured } from './supabase.js';

/**
 * Upload an image to Supabase Storage.
 * Returns the public URL of the uploaded image.
 */
export async function uploadImage(file) {
  if (!isSupabaseConfigured()) {
    // Return a data URL as fallback
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const fileExt = file.name.split('.').pop();
  const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExt}`;
  const filePath = `reports/${fileName}`;

  const { error } = await supabase.storage
    .from('report-images')
    .upload(filePath, file, {
      cacheControl: '3600',
      upsert: false,
    });

  if (error) {
    console.error('Error uploading image:', error);
    throw error;
  }

  return getImageUrl(filePath);
}

/**
 * Get the public URL for an image in storage.
 */
export function getImageUrl(path) {
  if (!isSupabaseConfigured()) return path;

  const { data } = supabase.storage
    .from('report-images')
    .getPublicUrl(path);

  return data.publicUrl;
}
